import { MrMuteToggle } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-mute-toggle', MrMuteToggle );
